// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1bGcJ","main-image":"Header_main-image__1YLdQ"};